import React from 'react';
import './HomeProjectCard.css';
import { NavHashLink } from 'react-router-hash-link';

const HomeProjectCard = (props) => {
    const {id,liveSite,name,tech,photo} = props.project;
    const {imageLg,imageSm} = photo;
    const animId = (parseInt(id.split('-')[1]))
    return (
        <div className="home-project-card-main-container">
            <div className="home-project-card-image-container">
                <div className="home-project-card-display-large" >
                    <img src={imageLg} alt="" />
                </div>
                <div className="home-project-card-display-small">
                    <img  src={imageSm} alt="" />
                </div>
            </div>
            <div className="home-project-info-section">
                <h2>{name}</h2>
                <p>{tech}</p>
                <div>
                    <a href={liveSite} rel="noreferrer" target="_blank"><button className="primary-btn">Live</button></a>
                    <NavHashLink to={`/project/${id}`}><button className="primary-btn">Details</button></NavHashLink>
                </div>
            </div>
        </div>
    );
};

export default HomeProjectCard;;